document.addEventListener('DOMContentLoaded', function() {
  // Find all data-edit-product-option elements
  const customizableElements = document.querySelectorAll('[data-edit-product-option]');
  
  customizableElements.forEach(element => {
    // Check if it's inside the main product container
    const isInMainProduct = !!element.closest('[data-main-product="true"]');
    const isInHorizontalProduct = !!element.closest('.tm-horizontal-product');
    
    // If it's not in the main product or it is in a horizontal product (upsell),
    // remove the data attribute so the customizer won't target it
    if (!isInMainProduct || isInHorizontalProduct) {
      element.removeAttribute('data-edit-product-option');
    }
  });
});